import React, { useEffect } from 'react'
import useTrans from '../../../../../hooks/useTrans'
import Button from '../../../../atoms/Button/Button'
import FormField from '../../../../atoms/FormField/FormField'
import FormInput from '../../../../atoms/FormInput/FormInput'
import { trackingRegistrazioneFunnel } from '../../../../../utils/gtm'

const Credenziali = ({ props, setStep, step }) => {
  const t = useTrans()

  useEffect(() => {
    !props.values.credenziali?.username &&
      props.setFieldValue('credenziali.username', props.values.utente.email)
  }, [])
  return (
    <div className="step-registrazione">
      <div className="step-registrazione__fieldsets">
        <FormField
          label={t('Username*')}
          status={
            props.touched.credenziali?.username && props.errors.credenziali?.username
              ? 'error'
              : props.touched.credenziali?.username && 'success'
          }
          errorMessage={props.errors?.credenziali?.username}
          className="step-registrazione__fieldset--full-row"
          id={"credenziali-username"}
        >
          <FormInput
            value={props.values.credenziali?.username}
            onBlur={props.handleBlur('credenziali.username')}
            onChange={props.handleChange('credenziali.username')}
            id={"credenziali-username"}
          />
        </FormField>
        <FormField
          label={t('password*')}
          status={
            props.touched.credenziali?.password && props.errors.credenziali?.password
              ? 'error'
              : props.touched.credenziali?.password && 'success'
          }
          errorMessage={props.errors?.credenziali?.password}
          id={"credenziali-password"}
        >
          <FormInput
            type="password"
            value={props.values.credenziali?.password}
            onBlur={props.handleBlur('credenziali.password')}
            onChange={props.handleChange('credenziali.password')}
            id={"credenziali-password"}
          ></FormInput>
        </FormField>
        <FormField
          label={t('conferma password*')}
          status={
            props.touched.credenziali?.conferma_password &&
            props.errors.credenziali?.conferma_password
              ? 'error'
              : props.touched.credenziali?.conferma_password && 'success'
          }
          errorMessage={props.errors?.credenziali?.conferma_password}
          id={"credenziali-conferma-password"}
        >
          <FormInput
            type="password"
            value={props.values.credenziali?.conferma_password}
            onBlur={props.handleBlur('credenziali.conferma_password')}
            onChange={props.handleChange('credenziali.conferma_password')}
            id={"credenziali-conferma-password"}
          ></FormInput>
        </FormField>
      </div>

      <p className="step-registrazione__legend">*{t('Campi obbligatori')}</p>

      <Button
        disabled={props.errors.credenziali || !props.dirty}
        label={t('Conferma dati')}
        variant="primary"
        size="medium"
        onClick={() => {
          trackingRegistrazioneFunnel(2)
          setStep(step + 1)
        }}
      />
    </div>
  )
}

export default Credenziali
